import React from 'react';
import { motion } from 'framer-motion';
import { Rocket, CheckCircle2, Clock } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function HeroSection() {
  const {
    t,
    currency
  } = useLanguage();
  return <section className="relative w-full min-h-[85vh] md:min-h-[90vh] flex items-center pt-12 md:pt-16 pb-16 md:pb-24 overflow-hidden" data-id="element-170">
      {/* Full-width banner background */}
      <div className="absolute inset-0 z-0" data-id="element-171">
        <img src="https://cdn.magicpatterns.com/uploads/dCLzAHKgBpTqWG2qMDxEEK/baner_kinetic.png" alt="" className="w-full h-full object-cover object-[center_20%] md:object-top" data-id="element-172" />
        {/* Lighter gradient overlay - only on left side for text readability */}
        <div className="absolute inset-0 bg-gradient-to-r from-brand-bg via-brand-bg/70 md:via-brand-bg/60 to-transparent" data-id="element-173"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-brand-bg/90 md:from-brand-bg/80 via-transparent to-transparent" data-id="element-174"></div>
      </div>

      {/* Decorative color accents */}
      <div className="absolute inset-0 z-[1] pointer-events-none opacity-20" data-id="element-175">
        <div className="absolute top-1/4 left-1/4 w-[400px] h-[400px] bg-brand-cyan rounded-full blur-[150px]" data-id="element-176"></div>
        <div className="absolute bottom-1/4 right-1/3 w-[300px] h-[300px] bg-brand-purple rounded-full blur-[120px]" data-id="element-177"></div>
      </div>

      <div className="container mx-auto px-4 md:px-12 relative z-10" data-id="element-178">
        <div className="max-w-3xl" data-id="element-179">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="flex flex-col gap-4 md:gap-6" data-id="element-180">
            <div className="inline-flex items-center gap-2 bg-brand-cyan/10 border border-brand-cyan/30 text-brand-cyan px-3 md:px-4 py-1 md:py-1.5 rounded-full text-xs md:text-sm font-semibold w-fit backdrop-blur-sm" data-id="element-181">
              <Rocket className="w-3 h-3 md:w-4 md:h-4" data-id="element-182" />
              <span className="whitespace-nowrap" data-id="element-183">{t('hero.badge')}</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold leading-tight" data-id="element-184">
              {t('hero.title1')}{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-cyan to-brand-purple" data-id="element-185">
                {t('hero.title2')}
              </span>
              <br data-id="element-186" />
              {t('hero.title3')}
            </h1>

            <p className="text-base md:text-lg lg:text-xl text-gray-300 max-w-xl" data-id="element-187">
              {t('hero.subtitle')}
            </p>

            <div className="flex flex-col gap-2 mt-2 md:mt-4" data-id="element-188">
              <div className="flex items-center gap-3 md:gap-4" data-id="element-189">
                <span className="text-xl md:text-2xl text-gray-500 line-through decoration-red-500/50 decoration-2" data-id="element-190">
                  {currency}499
                </span>
                <span className="text-3xl md:text-4xl font-bold text-brand-cta" data-id="element-191">
                  {currency}199
                </span>
              </div>
              <p className="text-xs md:text-sm text-brand-cyan font-medium" data-id="element-192">
                {t('hero.price.special')}
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 mt-4 md:mt-6" data-id="element-193">
              <a href="https://q5xkzi-4j.myshopify.com/cart/57520197402959:1?channel=buy_button" target="_blank" rel="noopener noreferrer" className="bg-brand-cta hover:bg-brand-ctaHover text-brand-darker font-bold text-base md:text-lg px-6 md:px-8 py-3 md:py-4 rounded-lg flex items-center justify-center gap-2 md:gap-3 transition-all duration-300 shadow-[0_0_20px_rgba(255,215,0,0.3)] hover:shadow-[0_0_30px_rgba(255,215,0,0.5)] hover:-translate-y-1" data-id="element-194">
                <Rocket className="w-4 h-4 md:w-5 md:h-5" data-id="element-195" />
                <span className="whitespace-nowrap" data-id="element-196">{t('hero.cta')}</span>
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 mt-3 md:mt-4 text-xs md:text-sm text-gray-400" data-id="element-197">
              <div className="flex items-center gap-2" data-id="element-198">
                <CheckCircle2 className="w-3 h-3 md:w-4 md:h-4 text-brand-cyan" data-id="element-199" />
                <span data-id="element-200">{t('hero.guarantee')}</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-201">
                <CheckCircle2 className="w-3 h-3 md:w-4 md:h-4 text-brand-cyan" data-id="element-202" />
                <span data-id="element-203">{t('hero.nohidden')}</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-204">
                <Clock className="w-3 h-3 md:w-4 md:h-4 text-brand-purple" data-id="element-205" />
                <span data-id="element-206">{t('hero.delivery')}</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}